import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    link: "Grant Access Video",
  },
  ja: {
    link: "アクセス設定ビデオ",
  },
  es: {
    link: "Vídeo de Conceder Acceso",
  },
});

class Grant_Acccess_Video extends Component {
  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const containerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const linkStyle = {
      textAlign: "center",
      textDecoration: "underline",
      color: "black",
    };

    return (
      <div style={containerStyle}>
        <a
          href="https://youtu.be/0I3q7mhI9QI?si=WQlBksIy9NrDKxKX"
          target="_blank"
          style={linkStyle}
        >
          {localizationStrings.link}
        </a>
      </div>
    );
  }
}

export default Grant_Acccess_Video;
